import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const ELEVAR_INTEGRATION_NAME = 'elevar';
export const ZElevarIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(ELEVAR_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=elevar.js.map